export default class ShareableCardMaker {

  constructor() {
    this.scale = Math.ceil(window.devicePixelRatio);
    this.postcardW = 500 * this.scale;
    this.postcardH = 330 * this.scale;
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.postcardW;
    this.canvas.height = this.postcardH;
    this.context = this.canvas.getContext('2d');
    this.context.imageSmoothingEnabled = false;

    this.stamp = new Image();
    this.stamp.src = "/poetic-postcard/images/stamp_card.svg";

  }

  async storeImageForShareable(assetId, url){

    let imageW = Math.ceil(this.postcardW / 2);
    let imageH = this.postcardH;
    url += `=w${imageW}-h${imageH}-dc`;

    this.assetIdStored = null;
    this.img = new Image();
    this.img.crossOrigin = "anonymous";

    return new Promise((resolve, reject) => {
      this.img.onload = () => resolve();
      this.img.onerror = reject;
      this.img.src = url;
    });

  }

  makeShareableCard(dominantColor,assetId){

    if(this.img.src != null){
      console.log("image loaded", this.img.src);
    }
    // get colors
    const colorMain = "#" + dominantColor;//document.body.style.getPropertyValue("--color-main");

    // clear rect
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.context.fillStyle = "#ffffff";
    this.context.fillRect(0,0, this.canvas.width, this.canvas.height);

    this.context.globalAlpha = 0.25;
    this.context.fillStyle = colorMain;
    this.context.fillRect(0,0, this.canvas.width, this.canvas.height);
    this.drawClip(20,20,50);
    this.context.globalAlpha = 1.0;

    this.context.fillStyle = "#ffffff";
    this.context.fillRect(20,20, this.canvas.width-20, this.canvas.height-20);

    this.drawClip(40,40,40);

    // draw background color
    this.context.fillStyle = colorMain;
    this.context.fillRect(0,0, this.canvas.width, this.canvas.height);

    // draw stamp
    let x = this.canvas.width-60*this.scale;
    let y = 70 * this.scale;
    let w = this.stamp.width * .35 * this.scale;
    let h = this.stamp.height * .35 * this.scale;
    let angle = 5 * (Math.PI/180);
    this.context.save();
    this.context.globalAlpha = 0.65;
    this.context.translate(x, y);
    this.context.rotate( angle );
    this.context.drawImage(this.stamp,-w/2,-h/2,w,h);
    this.context.restore();


    // draw image
    this.context.drawImage(this.img,0,0,this.img.width,this.img.height);

    // draw lines
    x = this.img.width + 20 * this.scale;
    y = 40 * this.scale;
    w = 130 * this.scale;
    h = 30 * this.scale;
    this.drawLineBox( x, y, w, h);

    w *= 1.15;
    y += 100 * this.scale;
    h /= 2;

    let totalLines = 3 + Math.floor( Math.random() * 3 );
    for(let i = 0; i < totalLines; i++){
      let offsetW = (Math.random() * 40 - 20) * this.scale;
      this.drawLineBox( x, y, w + offsetW, h);
      y += h * 2;
    }

    return this.canvas.toDataURL();
  }

  drawClip(x,y,radius){
    let width = this.canvas.width - (x*2);
    let height = this.canvas.height - (y*2);
    this.context.beginPath();
    this.context.moveTo(x + radius, y);
    this.context.lineTo(x + width - radius, y);
    this.context.quadraticCurveTo(x + width, y, x + width, y + radius);
    this.context.lineTo(x + width, y + height - radius);
    this.context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    this.context.lineTo(x + radius, y + height);
    this.context.quadraticCurveTo(x, y + height, x, y + height - radius);
    this.context.lineTo(x, y + radius);
    this.context.quadraticCurveTo(x, y, x + radius, y);
    this.context.closePath();

    this.context.clip();
  }

  drawLineBox(x,y,w,h){
    this.context.globalAlpha = 0.5;
    this.context.fillStyle = "#ffffff";
    this.context.beginPath();
    this.context.roundRect(x,y,w,h,4* this.scale);
    this.context.fill();
    this.context.globalAlpha = 1.0;

  }

  downloadCard(){
    let dt = this.canvas.toDataURL("image/png");
    let link = document.createElement("a");
    link.href = dt;
    link.download = "poempostcard.png";
    link.click();
  }

}
